import "./App.css";
import "./variables.css";
import InfoBox from "./components/InfoBox";
import info from "./info";
import projects from "./projects";
import Project from "./components/Project";
import Landing from "./components/Landing";
import Footer from "./components/Footer"

// The code below alternates the projects and infoboxes to be left-right-left-right.
const projectArray = projects.map((item, index) => {
    return <Project key={item.id} item={item} isLeft={index % 2 === 0? true : false}/>;
});

const infoboxes = info.map((item, index) => {
  return <InfoBox key={item.id} info={item}  isLeft={index % 2 === 0? true : false}/>;
});

export default function App() {
  return (
    <div>
      <Landing/>
      <div className="projects">
        <h1 className="projects--title">Experience</h1>
        {projectArray}
      </div>
      <div className="boxes">
        {infoboxes}
      </div>
      <Footer/>
    </div>
  );
}
